import { getClient } from '@/lib/restClient';
import { StoreManagementMasterStoreService } from '@/services/StoreManagement/MasterStores/StoreManagementMasterStoreService';

export const useStoreManagementMasterStoreDelete = async (
  id: number
): Promise<void> => {
  const storeManagementMasterStoreService =
    new StoreManagementMasterStoreService(getClient());
  return await storeManagementMasterStoreService.delete(id);
};
